import { t } from 'i18next';
import React, { useMemo } from 'react';
import { LocationEvent } from '../../../domain/models/locations/LocationEvent';
import { ReactComponent as CalendarIcon } from '../../../icons/calendar.svg';
import { ReactComponent as LeaderIcon } from '../../../icons/leader.svg';
import { ReactComponent as MapIcon } from '../../../icons/map.svg';
import { ReactComponent as XIcon } from '../../../icons/x_icon.svg';
import { getSiteType } from '../../../utils/SiteTypes';
import { openNewTab } from '../../../utils/UIUtils';
import EventDDayBadge from './EventDDayBadge';
import useArtistQuery from '../../../components/api/queries/useArtistQuery';

interface EventHeaderProps {
  eventDetail: LocationEvent;
}

const EventHeader: React.FC<EventHeaderProps> = ({ eventDetail }) => {
  // const bgShine = useSpring({
  //   from: { backgroundPosition: '0% 50%' },
  //   to: { backgroundPosition: '100% 50%' },
  //   config: { duration: 3000 },
  //   loop: true
  // });

  // const dDay = dDayCalculate(
  //   eventDetail.startDate.toDateString(),
  //   eventDetail.endDate.toDateString()
  // );

  // const dDayState = dDayStateCalculate(
  //   eventDetail.startDate.toDateString(),
  //   eventDetail.endDate.toDateString()
  // );

  const linkToTwitter = (twitterId: string) => {
    const twitterUrl = `https://x.com/${twitterId}`;

    // 모바일 환경 감지
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (isMobile) {
      // 모바일에서는 현재 창에서 열어서 딥링크 처리
      window.location.href = twitterUrl;
    } else {
      openNewTab(twitterUrl);
    }
  };

  const artist = useArtistQuery(eventDetail.artist.artistId);

  const getMemberNames = () => {
    if (artist?.members.length === eventDetail.members?.length) {
      return artist?.name;
    }
    return `${artist?.name} ${eventDetail.members?.map((member) => member.name).join(', ')}`;
  };
  
  const siteType = useMemo(() => getSiteType(eventDetail.category), [eventDetail.category]);

  console.log(eventDetail);
  

  return (
    <div
      className={`pt-[20px] pr-[20px] pb-[16px] pl-[20px] ${
        eventDetail.category === 'billboard_ad'
          ? 'bg-gradient-to-b from-white to-transparent dark:from-[#0D0E12] dark:to-transparent'
          : ''
      }`}
      style={{
        background: 'transparent'
      }}
    >
      {/* Event Information Section */}
      <div className="flex flex-row items-center text-[13px] leading-[16px]">
        {/* {dDayState === 'before' && (
          <div className="text-onTheirty-light text-[13px] bg-separator-light-1 rounded-[6px] px-[8px] py-[4px]">
            {dDay}
          </div>
        )}

        {dDayState === 'ongoing' && (
          <animated.div
            className="text-pure-white text-[13px] bg-[#444444] rounded-[6px] px-[8px] py-[4px]"
            style={{
              ...bgShine,
              backgroundImage:
                'linear-gradient(to right,#7953cd 20%,#00affa 30%,#0190cd 70%,#764ada 80%)',
              backgroundSize: '500% auto',
              whiteSpace: 'pre-wrap'
            }}
          >
            {dDay}
          </animated.div>
        )}

        {dDayState === 'endingToday' && (
          <div className="bg-separator-light-1 rounded-[6px] px-[8px] py-[4px] relative inline-block">
            <animated.div
              className="text-pure-white text-[13px] flex items-center justify-center"
              style={{
                backgroundImage: 'linear-gradient(to right, #7953cd, #00affa, #0190cd, #764ada)',
                backgroundSize: '200% auto',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                color: 'transparent',
                ...bgShine
              }}
            >
              {dDay}
            </animated.div>
          </div>
        )}

        {dDayState === 'ended' && (
          <div className="text-onDisabled-light text-[13px] bg-disabled-light rounded-[6px] px-[8px] py-[4px]">
            {dDay}
          </div>
        )} */}
        <EventDDayBadge
          startDate={eventDetail.startDate.toDateString()}
          endDate={eventDetail.endDate.toDateString()}
          size="medium"
        />
        <div className="flex flex-row items-center text-primary-light dark:text-primary-dark bg-surface-light dark:bg-surface-dark rounded-[6px] ml-[8px] px-[8px] py-[4px]">
          <img
            src={`/assets/icons/graphic-3d/${siteType?.iconName}.png`}
            alt="site_type_icon"
            className="w-[14px] h-[14px] mb-[2px] mr-[4px]"
          />
          <div className="text-[13px] leading-[16px] font-normal text-textPrimary-light dark:text-textPrimary-dark">
            {artist &&
              t('EventHeader.eventBadge', {
                members: getMemberNames(),
                siteType: siteType?.name
              })}
          </div>
        </div>

        {/* <animated.div
          className="text-pure-white text-[13px] bg-[#444444] rounded-[6px] ml-[8px] px-[8px] py-[4px]"
          style={{
            ...bgShine,
            backgroundImage:
              dDayState !== '종료'
                ? 'linear-gradient(to right,#7953cd 20%,#00affa 30%,#0190cd 70%,#764ada 80%)'
                : undefined,
            backgroundSize: dDayText !== '종료' ? '500% auto' : undefined,
            whiteSpace: 'pre-wrap'
          }}
        >
          {dDay}
        </animated.div> */}
      </div>

      {/* TODO Event DEtail */}
      {/* Event Information Section */}
      <div>
        <div className="flex mt-[6px] text-[27px] leading-[32px] text-main-light-1 dark:text-main-dark-1 font-bold">
          {eventDetail.name}
        </div>
      </div>
      <div className="flex flex-col mt-[14px] gap-[8px]">
        <div className="flex flex-row gap-[6px] text-[13px] leading-[16px] items-center text-main-light-3 dark:text-main-dark-3">
          <CalendarIcon className="w-[14px] h-[14px] fill-main-light-4 dark:fill-main-dark-4" />
          <div>
            {eventDetail.formatedStartDateString('yyyy.MM.dd')} ~{' '}
            {eventDetail.formatedEndDateString('yyyy.MM.dd')}
          </div>
        </div>
        {eventDetail.organizerTwitterId && (
          <div className="flex flex-row gap-[6px] text-[13px] leading-[16px] items-center text-main-light-3 dark:text-main-dark-3">
            <LeaderIcon className="w-[14px] h-[14px] flex-shrink-0  fill-main-light-4 dark:fill-main-dark-4" />
            <div className="leading-[16px] truncate">{eventDetail.organizerTwitterId}</div>
            <div
              className="rounded-[4px] w-[28px] h-[16px] bg-separator-light-1 dark:bg-separator-dark-1 px-[8px]py-[2px] flex items-center justify-center"
              onClick={() => linkToTwitter(eventDetail.organizerTwitterId)}
            >
              <XIcon className="w-3 h-3 fill-main-light-1 dark:fill-main-dark-1 cursor-pointer" />
            </div>
          </div>
        )}

        {eventDetail.location && (
          <div className="flex flex-row gap-[6px] text-[13px] leading-[16px] items-center text-main-light-3 dark:text-main-dark-3">
            <MapIcon className="w-[14px] h-[14px] fill-main-light-4 dark:fill-main-dark-4" />
            <div className="text-main-light-3 dark:text-main-dark-3">
              {eventDetail.location.name}
            </div>
            <div className="text-sub-light-1 dark:text-sub-dark-1">
              | {eventDetail.location.streetAddress}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventHeader;
